import React from "react";
import "./Header.css";
import AnchorLink from "react-anchor-link-smooth-scroll";
import Line from "../socials/Line";

const Header = (props) => {

    return (
        <div id="header">
            <AnchorLink href="#impression">
                <h1 className="site-title">Salon Calm</h1>
            </AnchorLink>
            <a href="https://page.line.me/474qslor" target="_blank" className="header-book"><Line className={"book-icon"} width={20} height={20} fill={"#f4cfcf"}  />で予約</a>
        </div>
    )
}

export default Header